import { render, staticRenderFns } from "./ShareTree.vue?vue&type=template&id=0cfab8ce&scoped=true&"
import script from "./ShareTree.vue?vue&type=script&lang=js&"
export * from "./ShareTree.vue?vue&type=script&lang=js&"
import style0 from "./ShareTree.vue?vue&type=style&index=0&id=0cfab8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfab8ce",
  null
  
)

export default component.exports